import { render, staticRenderFns } from "./MobileWarning.vue?vue&type=template&id=48d0c8e6&scoped=true"
import script from "./MobileWarning.vue?vue&type=script&lang=js"
export * from "./MobileWarning.vue?vue&type=script&lang=js"
import style0 from "./MobileWarning.vue?vue&type=style&index=0&id=48d0c8e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d0c8e6",
  null
  
)

export default component.exports